import React, {FC, useState} from "react"
import {H3, Label} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"
import {CashbackTransactionStatus, Wallet} from "@irati/types"
import {FormattedMessage} from "@irati/utils/lang"
import TabPills from "@irati/ui/src/TabPills"
import Flex from "@irati/ui/src/Flex"
import StatementItems from "../../StatementItems/StatementItems"
import {Transactions} from "./Transactions"

interface Props {
  wallet: Wallet
}

const CashbackHistory: FC<Props> = ({wallet}) => {
  const [selectedTab, setSelectedTab] = useState("transactions")

  const tabs = [
    {
      pill: (
        <Flex gap={0.5} alignItems="center" paddingLeft={5} paddingRight={5}>
          <Flex direction="row" gap={0.5}>
            <Label>
              <FormattedMessage id="wallet.tenant.transactionsHeader" />
            </Label>
          </Flex>
        </Flex>
      ),
      onClick: () => setSelectedTab("transactions"),
      isTabActive: selectedTab === "transactions"
    },
    {
      pill: (
        <Flex gap={0.5} alignItems="center" paddingLeft={5} paddingRight={5}>
          <Label>
            <FormattedMessage id="wallet.pointsRequests.rejected.title" />
          </Label>
        </Flex>
      ),
      onClick: () => setSelectedTab("rejected"),
      isTabActive: selectedTab === "rejected"
    }
  ]

  return (
    <div>
      <H3>
        <FormattedMessage id="wallet.cashback.statement.history.title" />
      </H3>
      <Spacing marginTop={1.5}>
        <TabPills tabs={tabs} />
        {selectedTab === "transactions" ? (
          <StatementItems wallet={wallet} hasCardStyle />
        ) : (
          <Transactions status={CashbackTransactionStatus.StatusCancelled} showZeroState />
        )}
      </Spacing>
    </div>
  )
}

export {CashbackHistory}
